function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon Design - Merged"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5 22a2.894 2.894 0 01-2.06-.854l-5.586-5.585a2.914 2.914 0 010-4.122l8.707-8.707A2.482 2.482 0 0113.328 2H20a2.003 2.003 0 012 2v6.672a2.482 2.482 0 01-.732 1.767l-8.707 8.707A2.894 2.894 0 0110.5 22zm2.828-19a1.51 1.51 0 00-1.06.44L3.56 12.145a1.914 1.914 0 000 2.707l5.586 5.586a1.961 1.961 0 002.707 0l8.707-8.707a1.51 1.51 0 00.439-1.06V4a1 1 0 00-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 4.75a.75.75 0 11-.75.75.75.75 0 01.75-.75m0-.75A1.5 1.5 0 1020 5.5 1.5 1.5 0 0018.5 4z"
})));